var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { resolve } from '@cvent/nucleus-dynamic-css';
import removeKeys from '../utils/removeKeys';
import { resolveTestId } from '@cvent/nucleus-test-automation';
import PropTypes from 'prop-types';
/**
  Button is a simple component that will render either the title or child objects
  passed by props.
 **/
var Button = /** @class */ (function (_super) {
    __extends(Button, _super);
    function Button(props) {
        var _this = _super.call(this, props) || this;
        _this.focus = function () {
            if (_this.button)
                _this.button.focus();
        };
        return _this;
    }
    Button.prototype.render = function () {
        var _this = this;
        var _a = removeKeys(this.props, ['classes']), children = _a.children, disabled = _a.disabled, _b = _a.kind, kind = _b === void 0 ? 'primary' : _b, _c = _a.type, type = _c === void 0 ? 'button' : _c, title = _a.title, breakPoint = _a.breakPoint, forwardedRef = _a.forwardedRef, rest = __rest(_a, ["children", "disabled", "kind", "type", "title", "breakPoint", "forwardedRef"]);
        return React.createElement("button", __assign({}, rest, { ref: forwardedRef || (function (c) { return _this.button = c; }) }, resolve(this.props, 'button', kind, disabled ? 'disabled' : null, breakPoint), resolveTestId(this.props), { disabled: disabled, title: title, type: type }), children || React.createElement("span", null, title));
    };
    Button.displayName = 'Button';
    Button.propTypes = {
        /** Child nodes to render inside button. */
        children: PropTypes.node,
        /** CSS Modlues Object */
        classes: PropTypes.shape({
            /** Main style for the button. */
            button: PropTypes.string,
            /** Secondary style applied based on button kind. */
            primary: PropTypes.string,
            /** Secondary style applied based on button kind. */
            secondary: PropTypes.string,
            /** Secondary style applied based on button kind. */
            disabled: PropTypes.string,
            /** Secondary style applied based on button kind. */
            link: PropTypes.string
        }),
        /** Displays as button text. */
        title: PropTypes.node,
        /** Disabled prop and style key for button */
        disabled: PropTypes.bool,
        /** Callback function. */
        onClick: PropTypes.func,
        /** Callback function. */
        onMouseOver: PropTypes.func,
        /** Callback function. */
        onMouseOut: PropTypes.func,
        /** Sets html button property. */
        type: PropTypes.oneOf(['button', 'submit', 'reset']),
        /** Changes style applied to button. 'primary', 'secondary', 'disabled', 'button', 'link' or other */
        kind: PropTypes.string,
        /** Breakpoint Class to be added **/
        breakPoint: PropTypes.oneOf(['mediaSmall', 'mediaMedium', 'mediaLarge', 'mediaAll']),
        forwardedRef: PropTypes.object,
        /** Available Style Keys. */
        style: PropTypes.shape({
            /** Main style for the button. */
            button: PropTypes.object,
            /** Secondary style applied based on button kind. */
            primary: PropTypes.object,
            /** Secondary style applied based on button kind. */
            secondary: PropTypes.object,
            /** Secondary style applied based on button kind. */
            disabled: PropTypes.object,
            /** Secondary style applied based on button kind. */
            link: PropTypes.object
        })
    };
    return Button;
}(React.Component));
export default Button;
